export default "__VITE_ASSET__GvWSqOYB__"